import { render, staticRenderFns } from "./EvalStatus.vue?vue&type=template&id=fbbf168e&scoped=true"
import script from "./EvalStatus.vue?vue&type=script&lang=js"
export * from "./EvalStatus.vue?vue&type=script&lang=js"
import style0 from "./EvalStatus.vue?vue&type=style&index=0&id=fbbf168e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbf168e",
  null
  
)

export default component.exports